export const START_FETCHING_UNITS_OF_MEASUREMENT = 'START_FETCHING_UNITS_OF_MEASUREMENT';
export const GET_UNITS_OF_MEASUREMENT_SUCCESS = 'GET_UNITS_OF_MEASUREMENT_SUCCESS';
export const GET_UNITS_OF_MEASUREMENT_ERROR = 'GET_UNITS_OF_MEASUREMENT_ERROR';
export const REMOVE_UNITS_OF_MEASUREMENT = 'REMOVE_UNITS_OF_MEASUREMENT';
